export function normalizeCurrencyCode(currency: string): string {
  return currency.toUpperCase();
}
